export const FETCH__ROLE_TYPE = "@attendances/FETC";
export const FETCH__ALL_LOCATION = "@attendances/DETC";
export const FETCH__ALL_EMPLOYEE = "@attendances/DETCemployee";
export const LOGIN = "@attendances/DETCemployeegdfgdfgdf";
export const LOGOUT = "@atgfhfghtendances/DETCemployeegdfgdfgdf";
